import { cn } from "@acme/utils";
import * as React from "react";

function ToggleRowGroup({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="toggle-row-group"
      className={cn("divide-y", className)}
      {...props}
    />
  );
}

function ToggleRow({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="toggle-row"
      className={cn(
        "flex items-start justify-between gap-4 py-4 first:pt-0 last:pb-0",
        className,
      )}
      {...props}
    />
  );
}

function ToggleRowContent({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="toggle-row-content"
      className={cn("flex-1 space-y-1", className)}
      {...props}
    />
  );
}

function ToggleRowLabel({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <div
      data-slot="toggle-row-label"
      className={cn("text-sm leading-none font-medium", className)}
      {...props}
    />
  );
}

function ToggleRowDescription({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      data-slot="toggle-row-description"
      className={cn("text-muted-foreground text-sm", className)}
      {...props}
    />
  );
}

function ToggleRowControl({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="toggle-row-control"
      className={cn("flex shrink-0 items-center pt-0.5", className)}
      {...props}
    />
  );
}

export {
  ToggleRow,
  ToggleRowContent,
  ToggleRowControl,
  ToggleRowDescription,
  ToggleRowGroup,
  ToggleRowLabel,
};
